export enum ERuntimeSettings {
  /** Манифест виджета авторизации **/
  loginWidgetManifest = 'loginWidgetB2CManifest',
  /** Манифест виджета калькулятора **/
  offerCalculatorManifest = 'offerCalculatorManifest',
  /** Дефолтный стейт калькулятора **/
  calculatorInitialValues = 'mortgage-promo-frontend.calculatorInitialValues',

  /** Фичатогл включения сео-данных **/
  isSeoDataEnabled = 'mortgage-promo-frontend.isSeoData.Enabled',

  /* PLATFORM */
  projectName = 'projectName',
  initialState = 'initialState',
  applicationContextCustom = 'applicationContext.custom',
  soprApiBaseUrl = 'soprApi.browserUrl',
  isWebView = 'web.isWebView',
  refinBannerEnabled = 'mortgage-promo-frontend.refinLeadBanner.Enabled',
  lifeInsuranceEnabled = 'mortgage-calculator-micro-frontend.lifeInsuranceField.Enabled',
  isSeoCrossLinksEnabled = 'mortgage-promo-frontend.isSeoCrosslinks.Enabled',
}
